import React, { useEffect, useState } from "react";
import { CentralLoadingIndicator, PastPetCard } from "../../../components";
import { usePastPetsList } from "../../../services/past-pets/past-pets.service";
import { IPetWithAge } from "../../../services/past-pets/past-pets.interface";

const PastPetsContainer = () => {
  const { getPastPets, pastPetsList, loading } = usePastPetsList();
  const [sortedPetsList, setSortedPetsList] = useState<IPetWithAge[]>([]);

  useEffect(() => {
    getPastPets();
  }, []);

  useEffect(() => {
    if (pastPetsList?.length) {
      const sortedList = [...pastPetsList].sort((a, b) => {
        if (!a.retiredOn) return 1;
        if (!b.retiredOn) return -1;

        return Number(b.retiredOn) - Number(a.retiredOn);
      });

      setSortedPetsList(sortedList);
    }
  }, [pastPetsList]);

  if (loading) {
    return <CentralLoadingIndicator />;
  }

  return (
    <div className="flex justify-center cursor-default mb-1.5">
      <div className="w-full max-w-[528px] flex flex-col items-center gap-2">
        <div className="w-full flex flex-col justify-between gap-5">
          {sortedPetsList && sortedPetsList.length > 0 && (
            <div className="flex flex-col gap-2">
              {sortedPetsList.map((petData, index) => (
                <PastPetCard
                  key={index}
                  name={petData.name}
                  breedName={petData.breedName}
                  image={petData.image}
                  birthdate={petData.birthdate}
                  retiredOn={petData.retiredOn}
                  isWellnessplan={petData.isWellnessplan}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PastPetsContainer;
